import { Globe, DollarSign } from "lucide-react";
import {
    DropdownMenu, DropdownMenuTrigger, DropdownMenuContent,
    DropdownMenuSeparator, DropdownMenuLabel, DropdownMenuCheckboxItem,
} from "@/components/ui/dropdown-menu";

export function NavSwitchers({ textColor, linkHover, curCode, setCurCode, currencies, lang, setLang, t }) {
    return (
        <>
            {/* Currency switch */}
            <DropdownMenu>
                <DropdownMenuTrigger data-testid="currency-switcher" className={`flex items-center gap-1 text-xs uppercase tracking-widest2 ${textColor} ${linkHover}`}>
                    <DollarSign size={14} /> {curCode}
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="w-40 rounded-sm">
                    <DropdownMenuLabel className="eyebrow">Currency</DropdownMenuLabel>
                    <DropdownMenuSeparator />
                    {Object.keys(currencies).map((c) => (
                        <DropdownMenuCheckboxItem key={c} data-testid={`currency-${c}`} checked={curCode === c} onCheckedChange={() => setCurCode(c)}>{c}</DropdownMenuCheckboxItem>
                    ))}
                </DropdownMenuContent>
            </DropdownMenu>

            {/* Language switch */}
            <DropdownMenu>
                <DropdownMenuTrigger data-testid="lang-switcher" className={`flex items-center gap-1.5 text-xs uppercase tracking-widest2 ${textColor} ${linkHover}`}>
                    <Globe size={14} /> {lang.toUpperCase()}
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="w-40 rounded-sm">
                    <DropdownMenuLabel className="eyebrow">{t("common.language")}</DropdownMenuLabel>
                    <DropdownMenuSeparator />
                    <DropdownMenuCheckboxItem data-testid="lang-en" checked={lang === "en"} onCheckedChange={() => setLang("en")}>English</DropdownMenuCheckboxItem>
                    <DropdownMenuCheckboxItem data-testid="lang-es" checked={lang === "es"} onCheckedChange={() => setLang("es")}>Español</DropdownMenuCheckboxItem>
                </DropdownMenuContent>
            </DropdownMenu>
        </>
    );
}
